import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { THEMES, DEFAULT_THEME_ID } from "./themes";

const ThemeContext = createContext({
  themeId: DEFAULT_THEME_ID,
  setThemeId: () => {},
  theme: THEMES[0]
});

function applyCssVars(theme) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.style.setProperty("--bg-1", theme.bg1);
  root.style.setProperty("--bg-2", theme.bg2);
  root.style.setProperty("--surface", theme.surface);
  root.style.setProperty("--text", theme.text);
  root.style.setProperty("--accent", theme.accent);
  root.style.setProperty("--chip", theme.chip);
}

export function ThemeProvider({ children }) {
  const [themeId, setThemeId] = useState(() => {
    try {
      const stored = localStorage.getItem("blockzie-theme");
      return stored || DEFAULT_THEME_ID;
    } catch (err) {
      return DEFAULT_THEME_ID;
    }
  });

  const theme = useMemo(
    () => THEMES.find((t) => t.id === themeId) || THEMES[0],
    [themeId]
  );

  useEffect(() => {
    applyCssVars(theme);
    try {
      localStorage.setItem("blockzie-theme", theme.id);
    } catch (err) {
      // ignore storage errors
    }
  }, [theme]);

  const value = useMemo(
    () => ({ themeId: theme.id, setThemeId, theme }),
    [theme.id]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
